export const lightTheme = {
  type: 'light',
  background: 'hsl(51, 39%, 93%)',
  backgroundA: 'hsla(51, 39%, 93%, 1)',
  bg1: 'hsla(60, 40%, 85%, .6)',
  bg2: 'hsla(130, 49%, 88%, .6)',
  bg3: 'hsla(181, 36%, 85%, .6)',
  bg4: 'hsla(200, 25%, 87%, .6)',
  color: 'hsl(60, 3%, 8%)',
  color100: 'hsl(60, 3%, 8%)',
  color200: 'hsl(45, 3%, 23%)',
  color300: 'hsl(47, 4%, 55%)',
  color400: 'hsl(47, 8%, 53%)',
  spiral: 'peru',
  tip: 'hsl(54, 68%, 49%)',
  weather: 'hsl(43, 88%, 46%)',
  }

export const darkTheme = {
  type: 'dark',
  background: 'hsl(210, 1%, 13%)',
  backgroundA: 'hsla(210, 1%, 13%, 1)',
  bg1: 'hsla(220, 13%, 15%, .6)',
  bg2: 'hsla(200, 12%, 16%, .6)',
  bg3: 'hsla(180, 11%, 17%, .6)',
  bg4: 'hsla(160, 10%, 18%, .6)',
  color: 'hsl(240, 1%, 78%)',
  color100: 'hsl(240, 3%, 93%)',
  color200: 'hsl(240, 1%, 78%)',
  color300: 'hsl(210, 2%, 47%)',
  color400: 'hsl(216, 5%, 21%)',
  spiral: 'lightcyan',
  tip: 'hsl(222, 97%, 46%)',
  weather: 'hsl(213, 60%, 70%)',
  }